import { TransformedLocaleConfig, LocaleName } from '../type';
const baseLocaleConfig = {
  name: 'sk',
  months: [
    'január',
    'február',
    'marec',
    'apríl',
    'máj',
    'jún',
    'júl',
    'august',
    'september',
    'október',
    'november',
    'december',
  ],
  monthsShort: ['jan', 'feb', 'mar', 'apr', 'máj', 'jún', 'júl', 'aug', 'sep', 'okt', 'nov', 'dec'],
  weekdays: ['nedeľa', 'pondelok', 'utorok', 'streda', 'štvrtok', 'piatok', 'sobota'],
  weekdaysMin: ['n', 'p', 'u', 's', 'š', 'p', 's'],
  weekdaysShort: ['ne', 'po', 'ut', 'st', 'št', 'pi', 'so'],
  formats: {
    LT: 'HH:mm',
    LTS: 'HH:mm:ss',
    lt: 'h:mm A',
    lts: 'h:mm:ss A',
    L: 'D.M.YYYY',
    LL: 'D. MMMM YYYY',
    'LL-D': 'MMMM YYYY',
    'LL-Y': 'D. MMMM',
    LLL: 'D. MMMM YYYY HH:mm',
    'LLL-Y': 'D. MMMM HH:mm',
    LLLL: 'dddd D. MMMM YYYY HH:mm',
    'LLLL-Y': 'dddd D. MMMM HH:mm',
    l: 'D.M.YYYY',
    'l-Y': 'D.M',
    ll: 'D. MMM YYYY',
    'll-Y': 'D. MMM',
    lll: 'D. MMM YYYY h:mm A',
    'lll-Y': 'D. MMM h:mm A',
    llll: 'ddd D. MMM YYYY h:mm A',
    'llll-Y': 'ddd D. MMM h:mm A',
    'll-Y+w': 'ddd D. M.',
    'LT+to': 'H:mm ([GMT]Z)',
    'LLL+to': 'D. MMMM YYYY, H:mm ([GMT]Z)',
  },
  meridiem: { am: 'dop.', pm: 'pop.', AM: 'dop.', PM: 'pop.' },
  past: {
    y: { one: 'pred %s r.', few: 'pred %s r.', many: 'pred %s r.', other: 'pred %s r.' },
    M: { one: 'pred %s mes.', few: 'pred %s mes.', many: 'pred %s mes.', other: 'pred %s mes.' },
    w: { one: 'pred %s týž.', few: 'pred %s týž.', many: 'pred %s týž.', other: 'pred %s týž.' },
    d: { one: 'pred %s d.', few: 'pred %s d.', many: 'pred %s d.', other: 'pred %s d.' },
    h: { one: 'pred %s h', few: 'pred %s h', many: 'pred %s h', other: 'pred %s h' },
    m: { one: 'pred %s min', few: 'pred %s min', many: 'pred %s min', other: 'pred %s min' },
    s: { one: 'pred %s s', few: 'pred %s s', many: 'pred %s s', other: 'pred %s s' },
  },
  future: {
    y: { one: 'o %s r.', few: 'o %s r.', many: 'o %s r.', other: 'o %s r.' },
    M: { one: 'o %s mes.', few: 'o %s mes.', many: 'o %s mes.', other: 'o %s mes.' },
    w: { one: 'o %s týž.', few: 'o %s týž.', many: 'o %s týž.', other: 'o %s týž.' },
    d: { one: 'o %s d.', few: 'o %s d.', many: 'o %s d.', other: 'o %s d.' },
    h: { one: 'o %s h', few: 'o %s h', many: 'o %s h', other: 'o %s h' },
    m: { one: 'o %s min', few: 'o %s min', many: 'o %s min', other: 'o %s min' },
    s: { one: 'o %s s', few: 'o %s s', many: 'o %s s', other: 'o %s s' },
  },
  abbr: {
    y: { one: '%s r.', few: '%s r.', many: '%s r.', other: '%s r.' },
    M: { one: '%s mes.', few: '%s mes.', many: '%s mes.', other: '%s mes.' },
    w: { one: '%s týž.', few: '%s týž.', many: '%s týž.', other: '%s týž.' },
    d: { one: '%s deň', few: '%s dni', many: '%s dňa', other: '%s dní' },
    h: { one: '%s h', few: '%s h', many: '%s h', other: '%s h' },
    m: { one: '%s min', few: '%s min', many: '%s min', other: '%s min' },
    s: { one: '%s s', few: '%s s', many: '%s s', other: '%s s' },
  },
  justNow: 'Práve teraz',
  yesterday: 'Včera',
  today: 'Dnes',
  tomorrow: 'Zajtra',
  weekStart: 1,
};
const localeName: LocaleName = 'sk';
export const localeConfig: TransformedLocaleConfig = {
  ...baseLocaleConfig,
  name: localeName,
  meridiem: (hour, _, isLowerCase = false): string => {
    if (hour < 12) {
      return isLowerCase ? 'dop.' : 'dop.';
    } else {
      return isLowerCase ? 'pop.' : 'pop.';
    }
  },
};
